<template>
  <div
    ref="collapseContainer"
    class="collapse"
    :class="{ 'collapse__content--expanded': !collapsed }"
  >
    <button
      class="collapse__title"
      data-toggle="collapse"
      :data-target="`#${id}`"
      :aria-expanded="`${collapsed ? 'true' : 'false'}`"
      :aria-controls="id"
      @click="toggleCollapse()"
    >
      <slot name="title"></slot>
      <slot name="indicator"></slot>
    </button>
    <div :id="id" class="collapse__content" :class="{ 'collapse__content--collapsed': collapsed }">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'collapse',
  props: {
    expanded: { require: false, default: false },
  },
  data() {
    return {
      collapsed: false,
      id: `collapse${Math.floor(Math.random() * 1000) + 1}`,
    };
  },
  mounted() {
    if (this.expanded) {
      this.toggleCollapse();
    }
    this.$nextTick(function () {
      if (this.$refs.collapseContainer.classList.contains('expanded')) {
        this.toggleCollapse();
      }
    });
  },
  methods: {
    toggleCollapse() {
      this.collapsed = !this.collapsed;
    },
  },
};
</script>

<style lang="scss">
.collapse__content {
  display: none;

  &--collapsed {
    display: block;
  }
}

.collapse__title {
  position: relative;

  &:focus {
    outline: none;
  }
}
</style>
